import * as React from 'react';
import {createAction} from '@packages/utilities/create-action';
import {styledDiv} from '@packages/utilities/styled';
import {Note, NoteLink} from '@packages/systems/spring';
import {Text} from '@packages/systems/design-system/Text';
import {panelOpened} from '@packages/systems/panels';
import {
  LEFT_SIDEBAR_SETTING_SELECTED,
  COMMERCE_SETTINGS_SELECTED,
} from '@packages/systems/designer/actions';
import {
  useDesignerSelector,
  useDispatch,
  type DesignerStores,
} from '@packages/systems/designer/flux';

const selectLeftSidebarSetting = createAction<
  typeof LEFT_SIDEBAR_SETTING_SELECTED,
  {settingName: 'payment' | 'commerce'}
>(LEFT_SIDEBAR_SETTING_SELECTED);
const commerceSettingsPanelSelected = createAction<
  typeof COMMERCE_SETTINGS_SELECTED,
  {settingName: 'payment'}
>(COMMERCE_SETTINGS_SELECTED);

const Gutters = styledDiv(({theme}) => ({
  marginTop: theme.gutters.base + 4,
}));

const selectQuickCheckoutEnabled = (state: DesignerStores) =>
  state.CommerceStore.settings.quickCheckoutEnabled;
const selectSettingsPanelSetting = (state: DesignerStores) =>
  state.UiStore.settingsPanelSetting;
const selectCommercePanelSetting = (state: DesignerStores) =>
  state.UiStore.commercePanelSetting;

export const WebPaymentsNote = () => {
  const quickCheckoutEnabled = useDesignerSelector(selectQuickCheckoutEnabled);
  const settingsPanelSetting = useDesignerSelector(selectSettingsPanelSetting);
  const commercePanelSetting = useDesignerSelector(selectCommercePanelSetting);
  const dispatch = useDispatch();

  const dispatchSidebarActions = () => {
    if (settingsPanelSetting !== 'commerce') {
      dispatch(
        selectLeftSidebarSetting({
          settingName: 'commerce',
        })
      );
    }
    if (commercePanelSetting !== 'payment') {
      dispatch(
        commerceSettingsPanelSelected({
          settingName: 'payment',
        })
      );
    }
  };

  const navigateToPaymentSettings = () => {
    dispatch(panelOpened('siteSettings'));
    dispatchSidebarActions();
  };

  return !quickCheckoutEnabled ? (
    <Gutters>
      <Note colorVariant="warning">
        <Text>
          Web Payments are disabled and will not be visible on your published
          site.
        </Text>
        <NoteLink onClick={navigateToPaymentSettings}>
          Enable Web Payments
        </NoteLink>
      </Note>
    </Gutters>
  ) : null;
};
